import { render, staticRenderFns } from "./default.layout.vue?vue&type=template&id=6c4aa13c&"
import script from "./default.layout.vue?vue&type=script&lang=js&"
export * from "./default.layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports